import { render, staticRenderFns } from "./IndividualB.vue?vue&type=template&id=7aa93d10&scoped=true"
import script from "./IndividualB.vue?vue&type=script&lang=js"
export * from "./IndividualB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa93d10",
  null
  
)

export default component.exports